<h1 id="step-heading" class="step-heading"><%= I18n.sign_in.title %></h1>

<div class="sign-in-intro">
  <p class="sign-in-intro-content"><%= I18n.sign_in.intro[appointment_slot.visit_type_category] %></p>
</div>
<div class="sign-in-selector">
  <div class="sign-in-option --option-1">
    <header class="sign-in-option-heading mychart-sign-in-logo">
      <%= I18n.sign_in.mychart.title %>
    </header>
    <p class="sign-in-option-instructions"><%= I18n.sign_in.mychart.message %></p>
    <span class="appointment-booking-wizard-sign-in-step-button mychart" data-behaviour="mychart-oauth" data-appointment-booking-wizard-behaviour="field-input" name="login_type" value="mychart" role="button" tabindex="0">
      <%= I18n.sign_in.mychart.continue %>
    </span>
  </div>

  <div class="divider"></div>

  <div class="sign-in-option --option-2">
    <header class="sign-in-option-heading">
      <%= I18n.sign_in.guest.title %>
    </header>
    <p class="sign-in-option-instructions"><%= I18n.sign_in.guest.message %></p>
    <span class="appointment-booking-wizard-sign-in-step-button guest" data-testid="<%= testIds.booking.guest %>" data-appointment-booking-wizard-behaviour="field-input" name="login_type" value="guest" role="button" tabindex="0">
      <%= I18n.sign_in.guest.continue %>
    </span>
  </div>
</div>
